<template>
	<div class="incomeAll">
		<h6>我的报告</h6>

		<section class="system">
			<article class="table">
				<hgroup class="flex">
					<p>服务</p>
					<p>时间</p>
					<p>操作</p>
				</hgroup>
				<ul>
					<li class="flex" v-for="(item, index) in list" :key="index">
						<p class="flexCenter">
							{{ item.Name }}
							<i @click="playVideo(item.VideoUrl)" v-if="item.VideoUrl"></i>
						</p>
						<p>{{ item.Date }}</p>
						<template v-if="item.Url">
							<p style="cursor: pointer; color: #333;" @click="checkPDF(item)">查看报告</p>
						</template>
						<template v-else>
							<p class="no-pdf" v-if="!item.IsReCreate">
								<span style="color: #333;">报告生成中,请等待后刷新页面查看</span>
							</p>
							<p class="no-pdf" v-else>
								<span style="color: #333;">PDF生成失败</span>
								<span style="cursor: pointer; color: #333;"
									@click="reCreatePdf(item.Id, item.Name)">重新生成报告</span>
							</p>
						</template>
					</li>
				</ul>
			</article>
			<div class="flex xend pageDiv">
				<el-pagination @current-change="handleCurrentChange" :current-page.sync="model.page"
					:page-size="model.pageSize" layout="total, prev, pager, next, jumper" :total="totalCount">
				</el-pagination>
			</div>
		</section>

		<!-- 视频 -->
		<aside class="popup flexCenter" v-if="isVideo">
			<div class="video zhan">
				<img src="../../image/vol-del-t.png" @click="isVideo = false" />
				<video :src="playUrl" controls autoplay class="shipin"></video>
			</div>
		</aside>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isVideo: false,
				model: {
					page: 1,
					pageSize: 10
				},
				totalCount: 0,
				list: [],
				playUrl: ''
			};
		},
		created() {
			this.getData();
		},
		methods: {
			playVideo: function(url) {
				if (url) {
					this.playUrl = url;
					this.isVideo = true;
				}
			},
			// 获取数据
			getData() {
				this.$api.getMyReport(this.model).then(res => {
					this.list = res.data.list;
					this.totalCount = res.data.totalCount;
				});
			},
			// 翻页
			handleCurrentChange(val) {
				this.getData();
			},
			// 查看pdf
			checkPDF(item) {
				var url = '';
				// ********测试代码后期删除**********
				if(!item.IsTime){
					url = item.Url;
					window.open(url);
					return;
				}
				// ********测试代码后期删除**********
				if (item.Name === '填:一键志愿填报') {
					if (item.Url.indexOf('jugongjiaoyue.oss-cn-beijing.aliyuncs.com') === -1) {
						url = 'https://jugongjiaoyue.oss-cn-beijing.aliyuncs.com/' + item.Url.replace('/Content/PdfFolder/', '');
						window.open(url);
					} else {
						url = item.Url;
						window.open(url);
					}
				} else {
					url = 'https://jugongjiaoyue.oss-cn-beijing.aliyuncs.com/' + item.Name + '-' + item.Id + '.pdf';
					window.open(url);
				}
			},
			// 重新生成pdf
			reCreatePdf(id, name) {
				const promise = name.includes('一键志愿填报') ? this.$api.reCreateVolunteerPdf({
					id
				}) : this.$api.reCreatePdf({
					id
				});
				promise.then(res => {
					if (res.code === 0) {
						this.$util.showOk(res.msg);
						this.getData();
					}
				});
			}
		}
	};
</script>

<style scoped>
	.video img {
		position: absolute;
		right: 10px;
		top: 10px;
		z-index: 1;
		width: 20px;
		height: 20px;
		cursor: pointer;
	}

	.shipin {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	.video {
		width: 800px;
		height: 60vh;
		background-color: #fff;
		padding: 60px 30px 30px 30px;
		box-sizing: border-box;
		border-radius: 10px;
		position: relative;
	}

	.table li p i {
		width: 30px;
		height: 24px;
		cursor: pointer;
		display: block;
		background: url(../../image/san/ma.png) no-repeat left top;
		background-size: 100% 100%;
		margin-left: 10px;
	}

	.pageDiv {
		overflow: hidden;
		margin-top: 20px;
	}

	.table li p {
		font-size: 14px;
		width: 33.33%;
		line-height: 60px;
		text-align: center;
	}

	.table li p {
		border-right: solid 1px #e6e6e6;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: 33.33%;
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	.system {
		overflow: hidden;
		padding: 20px;
	}

	/* safety */

	.incomeAll>h6 {
		border-bottom: solid 1px #e6e6e6;
		font-size: 16px;
		color: #333;
		height: 62px;
		line-height: 62px;
		text-indent: 20px;
		position: relative;
	}

	.incomeAll>h6::after {
		content: '';
		width: 68px;
		height: 2px;
		background-color: #333;
		position: absolute;
		left: 20px;
		bottom: 0;
		z-index: 0;
	}

	.no-pdf {
		display: flex;
		justify-content: space-around;
		padding: 0 40px;
	}
</style>
